import { CrownIcon } from "lucide-react";
import React, { useState } from "react";
import Modal from "./modal/Modal";

const SubscriptionModal = ({ currentPlan, onClose, onUpgrade }) => {
  const [isOpen, setIsOpen] = useState(true); // Set to true for preview

  const handleUpgrade = () => {
    onUpgrade(); // Call the upgrade function passed as a prop
    setIsOpen(false); // Close the modal after upgrade
  };
  return (
    <div>
      <Modal
        isOpen={true}
        onClose={onClose}
        width="w-full max-w-lg"
        label="Upgrade Your Plan"
      >
        <div className="flex flex-col items-center text-center px-6 py-8">
          <div className="flex items-center justify-center h-20 w-20 rounded-full bg-indigo-100 mb-6">
            <CrownIcon size={36} className="text-indigo-600" />
          </div>

          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Premium Feature Locked
          </h2>

          <p className="text-lg text-gray-600 mb-6">
            To access this premium feature and unlock all capabilities, you'll
            need to upgrade your subscription plan.
          </p>

          <div className="w-full mb-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex justify-between mb-1">
              <span className="font-medium text-gray-700 uppercase tracking-wide">
                {currentPlan} Plan
              </span>
              <span className="text-gray-500">Current</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-700 uppercase tracking-wide">
                Advance Plan
              </span>
              <span className="text-indigo-600">Recommended</span>
            </div>
          </div>

          <div className="flex gap-4 w-full">
            <button
              onClick={onClose}
              className="flex-1 py-3 px-4 text-gray-600 font-medium rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors"
            >
              Maybe Later
            </button>
            <button
              onClick={handleUpgrade}
              className="flex-1 py-3 px-4 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
            >
              Upgrade Now
            </button>
          </div>
        </div>
      </Modal>

      {/* Button to open modal for demo purposes */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg"
        >
          Show Subscription Modal
        </button>
      )}
    </div>
  );
};

export default SubscriptionModal;
